module.exports = __webpack_public_path__ + "static/media/BreathingTechniques.11cf5a9d.mp3";